import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgxMaskPipe } from 'ngx-mask';
import { CadastroService } from '../../../../services/cadastro.service';
import { Funcionario } from '../../../../models/cadastro.model';

@Component({
  selector: 'app-funcionarios',
  standalone: true,
  imports: [CommonModule, FormsModule, NgxMaskPipe],
  templateUrl: './funcionarios.component.html',
  styleUrl: './funcionarios.component.css'
})
export class FuncionariosComponent implements OnInit {
  funcionarios: Funcionario[] = [];
  filteredFuncionarios: Funcionario[] = [];
  paginatedFuncionarios: Funcionario[] = [];

  searchTerm = '';
  currentPage = 1;
  itemsPerPage = 10;
  totalPages = 1;

  maxPagesToShow = 5;
  startPage!: number;
  endPage!: number;
  pages: number[] = [];

  constructor(
    private cadastroService: CadastroService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.loadFuncionarios();
  }

  loadFuncionarios(): void {
    this.cadastroService.getFuncionarios().subscribe({
      next: (data) => {
        this.funcionarios = data;
        this.search();
      },
      error: () => {
        this.toastr.error('Erro ao carregar funcionários.');
      }
    });
  }

  search(): void {
    const term = this.searchTerm.toLowerCase();
    this.filteredFuncionarios = this.funcionarios.filter(funcionario =>
      funcionario.nome.toLowerCase().includes(term) ||
      funcionario.sobrenome.toLowerCase().includes(term) ||
      funcionario.cpf.toLowerCase().includes(term) ||
      funcionario.telefone.toLowerCase().includes(term) ||
      funcionario.cargoDescricao.toLowerCase().includes(term)
    );
    this.totalPages = Math.max(1, Math.ceil(this.filteredFuncionarios.length / this.itemsPerPage));
    this.setPage(1);
  }

  setPage(page: number): void {
    if (page < 1 || page > this.totalPages) {
      return;
    }

    this.currentPage = page;
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = Math.min(startIndex + this.itemsPerPage, this.filteredFuncionarios.length);
    this.paginatedFuncionarios = this.filteredFuncionarios.slice(startIndex, endIndex);
    this.updatePageNumbers();
  }

  updatePageNumbers(): void {
    const halfPages = Math.floor(this.maxPagesToShow / 2);
    this.startPage = Math.max(1, this.currentPage - halfPages);
    this.endPage = Math.min(this.totalPages, this.startPage + this.maxPagesToShow - 1);

    if (this.endPage - this.startPage + 1 < this.maxPagesToShow) {
      this.startPage = Math.max(1, this.endPage - this.maxPagesToShow + 1);
    }

    this.pages = Array.from({ length: (this.endPage - this.startPage) + 1 }, (_, i) => this.startPage + i);
  }

  novoFuncionario(): void {
    this.router.navigate(['/home', 'cadastro-funcionario-manutencao']);
  }

  editarFuncionario(id: number): void {
    this.router.navigate(['/home', 'cadastro-funcionario-manutencao', id]);
  }

  alterarSalario(id: number): void {
    this.router.navigate(['/home', 'cadastro-funcionario-salario', id]);
  }
}